(function () {
  'use strict';
  var root = document.getElementById('jw-stories');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var DAY = 86400000;
  var duration = Math.min(15, Math.max(5, parseFloat(root.dataset.duration) || 7)) * 1000;
  var maxStories = parseInt(root.dataset.max, 10) || 10;
  var resetMs = Math.max(5, parseFloat(root.dataset.reset) || 35) * 1000; // grey ring goes back to blue after this
  var SEEN_KEY = 'jw_stories_seen';
  var helper = /[?&]story-helper/.test(location.search); // dev aid: tap image to read X/Y %

  var logo = document.querySelector('.site-header .jw-story-icon');
  var link = logo && logo.querySelector('a');
  if (!logo || !link) return;

  var stories = load();
  if (!stories.length) return; // no live story: plain icon, no ring

  /* ---------- data ---------- */
  function load() {
    var now = Date.now(), out = [];
    root.querySelectorAll('script[data-story]').forEach(function (el) {
      try {
        var s = JSON.parse(el.textContent), start = s.ts * 1000;
        if ((!s.img && !s.video) || start > now + 60000 || now >= start + DAY) return; // scheduled or expired
        s.spots = (s.spots || []).filter(Boolean).slice(0, 4);
        out.push(s);
      } catch (e) {}
    });
    out.sort(function (a, b) { return a.ts - b.ts; });
    return out.slice(-maxStories);
  }

  /* seen = { storyId: timestamp of last view } */
  function readSeen() {
    try { var o = JSON.parse(localStorage.getItem(SEEN_KEY)); return o && !Array.isArray(o) ? o : {}; } catch (e) { return {}; }
  }
  function markSeen(id) {
    var o = readSeen(), n = Date.now();
    o[id] = n;
    for (var k in o) if (n - o[k] > 2 * DAY) delete o[k];
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(o)); } catch (e) {}
  }
  var ringTimer = 0;
  function refreshRing() {
    clearTimeout(ringTimer);
    var o = readSeen(), mx = 0, all = true;
    stories.forEach(function (s) { if (!o[s.id]) all = false; else mx = Math.max(mx, o[s.id]); });
    var grey = all && Date.now() - mx < resetMs; // grey only for resetMs after the last view, then blue again
    logo.classList.toggle('jw-ring--seen', grey);
    if (grey) ringTimer = setTimeout(refreshRing, Math.max(300, mx + resetMs - Date.now() + 50));
  }
  function firstUnseen() {
    var o = readSeen(), n = Date.now();
    for (var i = 0; i < stories.length; i++) if (!o[stories[i].id] || n - o[stories[i].id] >= resetMs) return i;
    return 0;
  }

  /* ---------- ring ---------- */
  logo.classList.add('jw-ring');
  link.setAttribute('aria-haspopup', 'dialog');
  link.setAttribute('title', 'View stories');
  refreshRing();
  (window.requestIdleCallback || setTimeout)(function () {
    var f = stories[firstUnseen()], u = f.img || f.poster;
    if (u) new Image().src = u;
  });
  link.addEventListener('click', function (e) {
    if (!load().length) return; // all expired meanwhile: normal link
    e.preventDefault();
    open();
  });

  /* ---------- viewer ---------- */
  var v = null, idx = 0, elapsed = 0, last = null, raf = 0, isVideo = false, soundOn = false;
  var loading = true, hold = false, held = false, holdTimer = 0, cardOpen = false, prevOverflow = '';

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    for (var k in attrs || {}) n.setAttribute(k, attrs[k]);
    return n;
  }
  function btn(cls, label, text) { var b = el('button', cls, { type: 'button', 'aria-label': label }); b.textContent = text; return b; }

  function build() {
    v = {};
    v.el = el('div', 'jw-story', { role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Stories' });
    v.stage = el('div', 'jw-story__stage');
    v.bars = el('div', 'jw-story__bars');
    v.img = el('img', 'jw-story__img', { alt: '', draggable: 'false' });
    v.vid = el('video', 'jw-story__video', { playsinline: '', preload: 'auto' });
    v.vid.muted = true; v.vid.playsInline = true;
    v.spots = el('div', 'jw-story__spots');
    v.close = btn('jw-story__close', 'Close stories', '\u00d7');
    v.mute = btn('jw-story__mute', 'Sound on or off', '\uD83D\uDD07'); v.mute.hidden = true;
    v.prev = btn('jw-story__nav jw-story__nav--prev', 'Previous story', '\u2039');
    v.next = btn('jw-story__nav jw-story__nav--next', 'Next story', '\u203a');
    v.card = el('div', 'jw-story__card'); v.card.hidden = true;
    v.name = el('div', 'jw-story__name');
    v.price = el('div', 'jw-story__price');
    v.view = el('a', 'jw-story__view'); v.view.textContent = 'View';
    var info = el('div'); info.appendChild(v.name); info.appendChild(v.price);
    v.card.appendChild(info); v.card.appendChild(v.view);
    [v.img, v.vid, v.spots, v.bars, v.close, v.mute, v.card].forEach(function (n) { v.stage.appendChild(n); });
    v.el.appendChild(v.prev); v.el.appendChild(v.stage); v.el.appendChild(v.next);

    v.close.addEventListener('click', close);
    v.prev.addEventListener('click', function () { go(-1); });
    v.next.addEventListener('click', function () { go(1); });
    v.mute.addEventListener('click', function () {
      soundOn = !soundOn; v.vid.muted = !soundOn;
      v.mute.textContent = soundOn ? '\uD83D\uDD0A' : '\uD83D\uDD07';
    });
    v.el.addEventListener('click', function (e) { if (e.target === v.el) close(); });

    v.stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button,a')) return;
      held = false; clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { hold = true; held = true; }, 220); // press and hold = pause
    });
    v.stage.addEventListener('pointerup', function (e) {
      if (e.target.closest('button,a')) return;
      clearTimeout(holdTimer);
      var wasHeld = held; hold = false; held = false;
      if (wasHeld) return;
      if (cardOpen) { closeCard(); return; }
      if (helper) { readout(e); return; }
      var r = v.stage.getBoundingClientRect();
      go(e.clientX - r.left < r.width * 0.4 ? -1 : 1); // left = previous, right = next
    });
    v.stage.addEventListener('pointercancel', function () { clearTimeout(holdTimer); hold = false; held = false; });
    v.stage.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  }

  function open() {
    stories = load();
    if (!stories.length) return;
    if (!v) build();
    v.bars.innerHTML = '';
    v.fills = stories.map(function () {
      var b = el('span', 'jw-story__bar'), f = el('i', 'jw-story__fill');
      b.appendChild(f); v.bars.appendChild(b); return f;
    });
    document.body.appendChild(v.el);
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    window.addEventListener('resize', fit);
    document.addEventListener('visibilitychange', resetClock);
    show(firstUnseen());
    v.close.focus();
    last = null; cancelAnimationFrame(raf); raf = requestAnimationFrame(tick);
  }

  function close() {
    cancelAnimationFrame(raf);
    stopVideo();
    document.removeEventListener('keydown', onKey);
    window.removeEventListener('resize', fit);
    document.removeEventListener('visibilitychange', resetClock);
    document.documentElement.style.overflow = prevOverflow;
    if (v && v.el.parentNode) v.el.parentNode.removeChild(v.el);
    refreshRing();
    link.focus();
  }

  function stopVideo() {
    if (!v) return;
    v.vid.onloadeddata = v.vid.onerror = v.vid.onended = null;
    try { v.vid.pause(); } catch (e) {}
    v.vid.removeAttribute('src');
  }

  function show(i) {
    idx = i; elapsed = 0; last = null; loading = true;
    var s = stories[i];
    closeCard();
    stopVideo();
    v.fills.forEach(function (f, j) { f.style.transform = 'scaleX(' + (j < i ? 1 : 0) + ')'; });
    v.spots.innerHTML = '';
    var done = function () { loading = false; };
    isVideo = !!s.video;
    if (isVideo) {
      v.img.style.display = 'none'; v.vid.style.display = 'block'; v.mute.hidden = false;
      v.mute.textContent = soundOn ? '\uD83D\uDD0A' : '\uD83D\uDD07';
      v.vid.muted = !soundOn;
      v.vid.poster = s.poster || s.img || '';
      v.vid.onloadeddata = done;
      v.vid.onended = function () { go(1); };
      v.vid.onerror = function () { // video failed: fall back to the picture on the normal timer
        isVideo = false; v.vid.style.display = 'none'; v.mute.hidden = true;
        var u = s.img || s.poster;
        if (u) { v.img.style.display = 'block'; v.img.src = u; }
        loading = false;
      };
      v.vid.src = s.video;
      try { v.vid.load(); } catch (e) {}
    } else {
      v.vid.style.display = 'none'; v.mute.hidden = true; v.img.style.display = 'block';
      v.img.onload = done; v.img.onerror = done;
      v.img.src = s.img;
    }
    fit();
    s.spots.forEach(function (sp) {
      var b = el('button', 'jw-story__spot', { type: 'button', 'aria-label': sp.title });
      b.style.left = sp.x + '%'; b.style.top = sp.y + '%';
      b.addEventListener('click', function (e) { e.stopPropagation(); openCard(sp); });
      v.spots.appendChild(b);
    });
    markSeen(s.id);
    var nx = stories[i + 1], nu = nx && (nx.img || nx.poster);
    if (nu) new Image().src = nu;
  }

  function go(dir) {
    var n = idx + dir;
    if (n >= stories.length) return close();
    if (n < 0) {
      elapsed = 0; last = null; v.fills[idx].style.transform = 'scaleX(0)';
      if (isVideo) try { v.vid.currentTime = 0; } catch (e) {}
      return;
    }
    show(n);
  }

  function fit() {
    if (!v) return;
    var s = stories[idx], ar = s.w && s.h ? s.w / s.h : 5 / 7;
    var vw = window.innerWidth, vh = window.innerHeight, small = vw < 760;
    var maxH = small ? vh : vh * 0.92, maxW = small ? vw : vw * 0.9;
    var w = Math.min(maxW, maxH * ar);
    v.stage.style.width = w + 'px';
    v.stage.style.height = w / ar + 'px';
  }

  function openCard(sp) {
    v.name.textContent = sp.title;
    v.price.textContent = sp.price;
    if (sp.compare) { var c = el('s'); c.textContent = sp.compare; v.price.appendChild(c); }
    if (sp.soldout) { var o = el('em'); o.textContent = 'Sold out'; v.price.appendChild(o); }
    v.view.setAttribute('href', sp.url);
    v.card.hidden = false; cardOpen = true; // timer and video pause while the card is open
  }
  function closeCard() { if (!v) return; v.card.hidden = true; cardOpen = false; }

  function readout(e) {
    var r = v.stage.getBoundingClientRect();
    var x = Math.round((e.clientX - r.left) / r.width * 100), y = Math.round((e.clientY - r.top) / r.height * 100);
    var old = v.stage.querySelectorAll('.jw-story__readout,.jw-story__cross');
    old.forEach(function (n) { n.remove(); });
    var cross = el('div', 'jw-story__cross'); cross.style.left = x + '%'; cross.style.top = y + '%';
    var pill = el('div', 'jw-story__readout'); pill.textContent = 'x: ' + x + '   y: ' + y;
    v.stage.appendChild(cross); v.stage.appendChild(pill);
  }

  function isPaused() { return loading || hold || cardOpen || helper || document.hidden; }
  function resetClock() { last = null; }
  function tick(t) {
    raf = requestAnimationFrame(tick);
    if (last === null) { last = t; return; }
    var dt = t - last; last = t;
    var paused = isPaused();
    if (isVideo) { // video slide: progress follows the video itself (max 60s)
      if (paused) { if (!v.vid.paused) try { v.vid.pause(); } catch (e) {} return; }
      if (v.vid.paused && !v.vid.ended) { try { var pr = v.vid.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {} }
      var d = v.vid.duration;
      if (d && isFinite(d)) v.fills[idx].style.transform = 'scaleX(' + Math.min(1, v.vid.currentTime / d) + ')';
      if (v.vid.currentTime >= 60) go(1);
      return;
    }
    if (paused) return;
    elapsed += dt;
    var p = Math.min(1, elapsed / duration);
    v.fills[idx].style.transform = 'scaleX(' + p + ')';
    if (p >= 1) go(1);
  }

  function onKey(e) {
    if (e.key === 'Escape') { cardOpen ? closeCard() : close(); }
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'Tab') { // keep focus inside the viewer
      var f = Array.prototype.filter.call(v.el.querySelectorAll('button,a[href]'), function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }
  }
})();